import { WorkspaceSeedListsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/seed-lists/')({
  component: WorkspaceSeedListsRoute,
});
